/**
 * Container for Job Modification Form
 *
 * @prettier
 * @author Russell Lilljedahl
 */

import React from 'react'

import JobModificationForm from 'app/gears/admin/jobs/components/JobModificationForm'
import { userHasFunctionality } from 'app/utils/userUtils'
import { connect } from 'react-redux'
import { updateJob } from 'app/gears/admin/jobs/actions/jobActions'

/**
 * Passes initial job values to the form and verifies.
 *
 * @param {Object} job Values related to the job being viewed.
 * @param {Object} updateJob Primary action method
 *
 */
const JobModificationContainer = ({ job, updateJob }) => (
  <JobModificationForm
    form='jobModificationForm'
    initialValues={{ ...job, isEnabled: job.isEnabled ? 'true' : 'false' }}
    onSubmit={updateJob}
    job={job}
  />
)

const mapStateToProps = state => ({
  ...state.jobState,
  userCanStartJobs: userHasFunctionality(state.currentUser, 'Run Jobs')
})

const mapDispatchToProps = { updateJob }

export default connect(mapStateToProps, mapDispatchToProps)(JobModificationContainer)
